import { useState } from "react";
import { FiArrowDownRight, FiChevronDown, FiChevronUp } from "react-icons/fi";

const IMAGE = {};
const MEGA_MENU_IMAGES = {
  services: "https://media.abym.in/Abym-Web/post/service-img.webp",
  products: "https://media.abym.in/Abym-Web/post/product-header.webp",
  industries: "https://media.abym.in/Abym-Web/post/industry-img.webp",
  about: "https://media.abym.in/Abym-Web/post/about-abym-header.webp",
};

const DiagonalArrow = () => (
  <FiArrowDownRight className="nav-arrow-icon" size={15} />
);

const Header = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(null); // which mobile accordion is open

  const pathname = window.location.pathname;
  const isSpecialPage = pathname === "/performance-marketing";

  const navItems = [
    { label: "Services", href: "/services", isMegaService: true },
    { label: "Products", href: "/", isMegaProduct: true },
    { label: "Industries", href: "/industries", isMega: true },
    { label: "Portfolio", href: "https://abym.in/portfolio" },
    { label: "About us", href: "/about-us", isMegaAbout: true },
    { label: "Blogs", href: "https://abym.in/blog" },
  ];

  const specialMenu = [
    {
      icon: IMAGE.whatsAppSeo,
      label: "+91 9958663840",
      href: "https://wa.me/919958663840",
      isSimple: true,
    },
    {
      icon: IMAGE.emailSeoHeader,
      label: "info@abym.in",
      href: "mailto:info@abym.in",
      isSimple: true,
    },
    { label: "Request A Quote", href: "#request-a-quote", isSimple: true },
  ];

  const menuList = isSpecialPage ? specialMenu : navItems;


  const MEGA_SERVICE_MENU = {
    footer: {
      text: "We're just a message away from transforming your business.",
      cta: { label: "Consult Our Experts", href: "https://abym.in/contact-us" },
    },
    columns: [
      {
        title: "PRODUCT DEVELOPMENT",
        items: [
          {
            label: "Artificial Intelligence & Machine Learning",
            children: [
              { label: "Generative AI", href: "https://abym.in/services" },
              { label: "Computer Vision", href: "https://abym.in/services" },
              {
                label: "Predictive Analytics",
                href: "https://abym.in/services",
              },
              { label: "NLP Solutions", href: "https://abym.in/services" },
            ],
          },
          {
            label: "Mobile App Development",
            children: [
              {
                label: "iOS App Development",
                href: "https://abym.in/services",
              },
              {
                label: "Android App Development",
                href: "https://abym.in/services",
              },
              { label: "Flutter Apps", href: "https://abym.in/services" },
              { label: "React Native Apps", href: "https://abym.in/services" },
            ],
          },
          {
            label: "Software Development",
            children: [
              { label: "SaaS Platforms", href: "https://abym.in/services" },
              { label: "CRM Systems", href: "https://abym.in/services" },
              { label: "ERP Development", href: "https://abym.in/services" },
            ],
          },
          {
            label: "Digital Marketing",
            children: [
              { label: "SEO", href: "https://abym.in/services" },
              { label: "PPC", href: "https://abym.in/services" },
              {
                label: "Social Media Marketing",
                href: "https://abym.in/services",
              },
              {
                label: "Performance Marketing",
                href: "https://abym.in/services",
              },
            ],
          },
          {
            label: "Server Support & DevOps",
            children: [
              { label: "AWS & Cloud", href: "https://abym.in/services" },
              { label: "CI/CD Pipelines", href: "https://abym.in/services" },
              { label: "Monitoring", href: "https://abym.in/services" },
            ],
          },
          {
            label: "QA & Testing",
            children: [
              { label: "Automation Testing", href: "https://abym.in/services" },
              { label: "Manual QA", href: "https://abym.in/services" },
              {
                label: "Performance Testing",
                href: "https://abym.in/services",
              },
            ],
          },
          {
            label: "IT Consulting",
            children: [
              { label: "Technology Roadmap", href: "https://abym.in/services" },
              { label: "Architecture Design", href: "https://abym.in/services" },
            ],
          },
          {
            label: "Product Design & Ideation",
            children: [
              { label: "UI/UX", href: "https://abym.in/services" },
              { label: "Wireframing", href: "https://abym.in/services" },
              { label: "MVP Design", href: "https://abym.in/services" },
            ],
          },
        ],
      },
      {
        title: "INTELLIGENCE HUB",
        items: [
          {
            label: "Custom AI & Autonomous Agents",
            href: "https://abym.in/services/ai-application",
          },
          {
            label: "AI-Native Mobile & Web Development",
            href: "https://abym.in/services/ai-native",
          },
          {
            label: "Enterprise Digital Transformation (DX)",
            href: "https://abym.in/services/digital-transformation",
          },
          {
            label: "Search & Answer Engine Optimization",
            href: "https://abym.in/services/seo-aeo",
          },
          {
            label: "Blockchain & Secure Identity",
            href: "https://abym.in/services/blockchain",
          },
          { label: "Seo is no Longer Enough", href: "https://abym.in/services/seo-nolonger" },
        ],
      },
    ],
  };

  const MEGA_ABOUT_MENU = {
    footer: {
      text: "We're just a message away from transforming your business.",
      cta: { label: "Consult Our Experts", href: "https://abym.in/contact-us" },
    },
    section: {
      title: "About ABYM",
      items: [
        { label: "Who Are We", href: "https://abym.in/about-us" },
        { label: "Our Design Process", href: "https://abym.in/about-us" },
        { label: "Partners", href: "https://abym.in/about-us" },
        { label: "Brand Story", href: "https://abym.in/about-us" },
        { label: "Testimonials", href: "https://abym.in/about-us" },
        { label: "Career", href: "https://abym.in/career" },
      ],
    },
  };

  const MEGA_INDUSTRIES_MENU = {
    footer: {
      text: "We're just a message away from transforming your business.",
      cta: { label: "Consult Our Experts", href: "https://abym.in/contact-us" },
    },
    columns: [
      [
        { label: "Healthcare", href: "https://abym.in/industries#healthcare" },
        { label: "eCommerce", href: "https://abym.in/industries#ecommerce" },
        { label: "Education", href: "https://abym.in/industries#education" },
        { label: "Wellness", href: "https://abym.in/industries" },
        { label: "Tour & Travel", href: "https://abym.in/industries" },
        { label: "Skill Development", href: "https://abym.in/industries" },
        { label: "FinTech", href: "https://abym.in/industries" },
        { label: "Banking", href: "https://abym.in/industries" },
      ],
      [
        { label: "Entertainment / Media", href: "https://abym.in/industries" },
        { label: "Games", href: "https://abym.in/industries#games" },
        { label: "Logistics", href: "https://abym.in/industries#logistics" },
        { label: "Agriculture", href: "https://abym.in/industries" },
        { label: "Energy", href: "https://abym.in/industries/energy" },
        { label: "Restaurant", href: "https://abym.in/industries/restaurant" },
        { label: "More", href: "https://abym.in/industries" },
      ],
    ],
  };

  const MEGA_PRODUCT_MENU = {
    footer: {
      text: "We're just a message away from transforming your business.",
      cta: { label: "Consult Our Experts", href: "https://abym.in/contact-us" },
    },
    section: {
      title: "PRODUCTS",
      items: [
        {
          label: "Digital Anumati",
          href: "https://digitalanumati.com/",
          newTab: true,
        },
        { label: "Lumenario", href: "https://lumenario.com/", newTab: true },
      ],
    },
  };

  /* ── Desktop Mega Footer ─────────────────────────────── */
  const MegaFooter = ({ text, cta }) => (
    <div
      className="d-flex justify-content-between align-items-center p-3"
      style={{ borderTop: "1px dashed #3B3B3B" }}
    >
      <p className="mb-0 small fw-semibold text-secondary">{text}</p>
      <a
        href={cta.href}
        className="btn btn-sm rounded-pill px-3 text-white"
        style={{
          background: "linear-gradient(186.93deg,#1382F3 5.6%,#015DBB 94.76%)",
          border: "none",
        }}
      >
        {cta.label}
      </a>
    </div>
  );

  const MegaMenuImage = ({ src, alt }) => (
    <div className="mega-menu-image-card">
      <img src={src} alt={alt} />
    </div>
  );

  /* ── Mobile accordion toggle helper ─────────────────── */
  const toggleMobile = (key) =>
    setMobileOpen((prev) => (prev === key ? null : key));

  /* ── Mobile sub-links renderer ───────────────────────── */
  const MobileLinks = ({ items }) => (
    <div className="mobile-sub-links">
      {items.map((item, i) => (
        <a
          key={i}
          href={item.href}
          target={item.newTab ? "_blank" : undefined}
          rel={item.newTab ? "noopener noreferrer" : undefined}
          className="mobile-sub-link"
        >
          {item.label}
        </a>
      ))}
    </div>
  );

  return (
    <header>
      <div
        className="fixed-top w-100"
        style={{ zIndex: 999, backgroundColor: "#000" }}
      >
        <div className="container-xl">
          {/* Top Bar */}
          <div
            className="text-center text-white py-1 pt-2"
            style={{ fontSize: "13px" }}
          >
            Get a free consultation from our experts &gt;
          </div>

          {/* Main Navbar */}
          <nav className="navbar navbar-expand-lg header-pill mt-1 px-3 py-1">
            {/* Logo */}
            <a href="/" className="navbar-brand ms-2">
              <img
                src="https://media.abym.in/Abym-Web/logo/abym-logo.webp"
                alt="AbymLogo"
                style={{ width: "120px" }}
              />
            </a>

            {/* Mobile Toggle */}
            <button
              className="navbar-toggler border-0 mobile-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNav"
              aria-controls="mainNav"
              aria-expanded="false"
            >
              <span className="navbar-toggler-icon" />
            </button>

            <div className="collapse navbar-collapse" id="mainNav">
              {/* ═══════════ DESKTOP NAV ═══════════ */}
              <ul className="navbar-nav mx-auto gap-lg-2 align-items-lg-center d-none d-lg-flex">
                {menuList.map((item, index) => {
                  if (item.isMega)
                    return (
                      <li key={index} className="nav-item dropdown">
                        <a
                          className="nav-link nav-link-custom dropdown-toggle-custom d-flex align-items-center gap-1"
                          href="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          {item.label} <DiagonalArrow />
                        </a>
                        <div className="dropdown-menu mega-dropdown p-0">
                          <div className="p-4 row g-3">
                            <div className="col-7">
                              <div className="row g-2 position-relative">
                                {MEGA_INDUSTRIES_MENU.columns.map((col, ci) => (
                                  <div key={ci} className="col-6">
                                    {col.map((ind, i) => (
                                      <a
                                        key={i}
                                        href={ind.href}
                                        className="industry-link"
                                      >
                                        {ind.label}
                                      </a>
                                    ))}
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div className="col-5">
                              <MegaMenuImage
                                src={MEGA_MENU_IMAGES.industries}
                                alt="ABYM Industries"
                              />
                            </div>
                          </div>
                          <MegaFooter {...MEGA_INDUSTRIES_MENU.footer} />
                        </div>
                      </li>
                    );

                  if (item.isMegaService)
                    return (
                      <li key={index} className="nav-item dropdown">
                        <a
                          className="nav-link nav-link-custom dropdown-toggle-custom d-flex align-items-center gap-1"
                          href="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          {item.label} <DiagonalArrow />
                        </a>
                        <div className="dropdown-menu mega-dropdown-lg p-0">
                          <div className="p-4 row g-3">
                            <div className="col-7">
                              <div className="row g-2 position-relative">
                                {MEGA_SERVICE_MENU.columns.map((col, ci) => (
                                  <div key={ci} className="col-6">
                                    <div className="section-title">
                                      {col.title}
                                    </div>
                                    {ci === 0 &&
                                      col.items.map((svc, i) => {
                                        const isOpen = openIndex === i;
                                        return (
                                          <div key={i} className="mb-1">
                                            <button
                                              className="accordion-btn"
                                              onClick={() =>
                                                setOpenIndex(isOpen ? null : i)
                                              }
                                            >
                                              <span>{svc.label}</span>
                                              <span>{isOpen ? "−" : "+"}</span>
                                            </button>
                                            {isOpen && (
                                              <ul
                                                className="ps-3 mt-1"
                                                style={{ listStyle: "none" }}
                                              >
                                                {svc.children.map(
                                                  (child, c) => (
                                                    <li key={c}>
                                                      <a
                                                        href={child.href}
                                                        className="intel-link"
                                                        style={{
                                                          fontSize: "12px",
                                                          color: "#6b7280",
                                                        }}
                                                      >
                                                        {child.label}
                                                      </a>
                                                    </li>
                                                  ),
                                                )}
                                              </ul>
                                            )}
                                          </div>
                                        );
                                      })}
                                    {ci === 1 &&
                                      col.items.map((svc, i) => (
                                        <a
                                          key={i}
                                          href={svc.href}
                                          className="intel-link"
                                        >
                                          {svc.label}
                                        </a>
                                      ))}
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div className="col-5">
                              <MegaMenuImage
                                src={MEGA_MENU_IMAGES.services}
                                alt="ABYM Services"
                              />
                            </div>
                          </div>
                          <MegaFooter {...MEGA_SERVICE_MENU.footer} />
                        </div>
                      </li>
                    );

                  if (item.isMegaAbout)
                    return (
                      <li key={index} className="nav-item dropdown">
                        <a
                          className="nav-link nav-link-custom dropdown-toggle-custom d-flex align-items-center gap-1"
                          href="#"
                          data-bs-toggle="dropdown"
                        >
                          {item.label} <DiagonalArrow />
                        </a>
                        <div className="dropdown-menu mega-dropdown-sm p-0">
                          <div className="p-4 row g-3">
                            <div className="col-5">
                              <div className="section-title">
                                {MEGA_ABOUT_MENU.section.title}
                              </div>
                              {MEGA_ABOUT_MENU.section.items.map((ab, i) => (
                                <a key={i} href={ab.href} className="intel-link">
                                  {ab.label}
                                </a>
                              ))}
                            </div>
                            <div className="col-7">
                              <MegaMenuImage
                                src={MEGA_MENU_IMAGES.about}
                                alt="About ABYM"
                              />
                            </div>
                          </div>
                          <MegaFooter {...MEGA_ABOUT_MENU.footer} />
                        </div>
                      </li>
                    );

                  if (item.isMegaProduct)
                    return (
                      <li key={index} className="nav-item dropdown">
                        <a
                          className="nav-link nav-link-custom dropdown-toggle-custom d-flex align-items-center gap-1"
                          href="#"
                          data-bs-toggle="dropdown"
                        >
                          {item.label} <DiagonalArrow />
                        </a>
                        <div className="dropdown-menu mega-dropdown-sm p-0">
                          <div className="p-4 row g-3">
                            <div className="col-5">
                              <div className="section-title">
                                {MEGA_PRODUCT_MENU.section.title}
                              </div>
                              {MEGA_PRODUCT_MENU.section.items.map((pr, i) => (
                                <a
                                  key={i}
                                  href={pr.href}
                                  target={pr.newTab ? "_blank" : undefined}
                                  rel={
                                    pr.newTab ? "noopener noreferrer" : undefined
                                  }
                                  className="intel-link"
                                >
                                  {pr.label}
                                </a>
                              ))}
                            </div>
                            <div className="col-7">
                              <MegaMenuImage
                                src={MEGA_MENU_IMAGES.products}
                                alt="ABYM Products"
                              />
                            </div>
                          </div>
                          <MegaFooter {...MEGA_PRODUCT_MENU.footer} />
                        </div>
                      </li>
                    );

                  if (item.isSimple) {
                    const isQuote = item.label === "Request A Quote";
                    return (
                      <li key={index} className="nav-item">
                        <a
                          href={item.href}
                          target={
                            item.href?.startsWith("http") ? "_blank" : undefined
                          }
                          rel={
                            item.href?.startsWith("http")
                              ? "noopener noreferrer"
                              : undefined
                          }
                          className={
                            isQuote
                              ? "btn btn-light btn-sm rounded-pill px-4 text-primary fw-semibold"
                              : "nav-link nav-link-custom d-flex align-items-center gap-2"
                          }
                        >
                          {item.label}
                        </a>
                      </li>
                    );
                  }

                  return (
                    <li key={index} className="nav-item">
                      <a
                        href={item.href}
                        className="nav-link nav-link-custom d-flex align-items-center gap-1"
                      >
                        {item.label} <DiagonalArrow />
                      </a>
                    </li>
                  );
                })}
              </ul>

              {/* Desktop Contact Us */}
              {!isSpecialPage && (
                <a
                  href="https://abym.in/contact-us"
                  className="btn btn-light rounded-pill px-4 py-2 fw-semibold ms-lg-3 d-none d-lg-inline-flex contact-btn"
                >
                  Contact Us
                </a>
              )}

              {/* ═══════════ MOBILE NAV ═══════════ */}
              <div className="d-flex d-lg-none flex-column mobile-nav">
                {menuList.map((item, index) => {
                  const key = `mobile-${index}`;
                  const isOpen = mobileOpen === key;

                  /* Has dropdown */
                  const hasDropdown =
                    item.isMega ||
                    item.isMegaService ||
                    item.isMegaAbout ||
                    item.isMegaProduct;

                  if (hasDropdown) {
                    let subLinks = [];
                    if (item.isMega)
                      subLinks = [
                        ...MEGA_INDUSTRIES_MENU.columns[0],
                        ...MEGA_INDUSTRIES_MENU.columns[1],
                      ];
                    if (item.isMegaAbout)
                      subLinks = MEGA_ABOUT_MENU.section.items;
                    if (item.isMegaProduct)
                      subLinks = MEGA_PRODUCT_MENU.section.items;

                    return (
                      <div key={index} className="mobile-nav-item">
                        <button
                          className="mobile-nav-btn"
                          onClick={() => toggleMobile(key)}
                        >
                          <span>{item.label}</span>
                          {isOpen ? (
                            <FiChevronUp size={16} />
                          ) : (
                            <FiChevronDown size={16} />
                          )}
                        </button>

                        {isOpen && (
                          <div className="mobile-dropdown">
                            {/* Services — show both columns */}
                            {item.isMegaService && (
                              <>
                                {MEGA_SERVICE_MENU.columns.map((col, ci) => (
                                  <div key={ci} className="mb-2">
                                    <div className="mobile-section-title">
                                      {col.title}
                                    </div>
                                    {ci === 0
                                      ? col.items.map((svc, i) => (
                                          <div key={i}>
                                            <div className="mobile-accordion-label">
                                              {svc.label}
                                            </div>
                                            {svc.children.map((child, c) => (
                                              <a
                                                key={c}
                                                href={child.href}
                                                className="mobile-child-link"
                                              >
                                                {child.label}
                                              </a>
                                            ))}
                                          </div>
                                        ))
                                      : col.items.map((svc, i) => (
                                          <a
                                            key={i}
                                            href={svc.href}
                                            className="mobile-sub-link"
                                          >
                                            {svc.label}
                                          </a>
                                        ))}
                                  </div>
                                ))}
                              </>
                            )}

                            {/* Other dropdowns */}
                            {!item.isMegaService && (
                              <MobileLinks items={subLinks} />
                            )}

                            {/* Footer CTA */}
                            <a
                              href="https://abym.in/contact-us"
                              className="mobile-cta-btn mt-2"
                            >
                              Consult Our Experts
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  }

                  /* Simple item */
                  if (item.isSimple) {
                    const isQuote = item.label === "Request A Quote";
                    return (
                      <div key={index} className="mobile-nav-item">
                        <a
                          href={item.href}
                          target={
                            item.href?.startsWith("http") ? "_blank" : undefined
                          }
                          rel={
                            item.href?.startsWith("http")
                              ? "noopener noreferrer"
                              : undefined
                          }
                          className={
                            isQuote ? "mobile-cta-btn" : "mobile-nav-link"
                          }
                        >
                          {item.label}
                        </a>
                      </div>
                    );
                  }

                  return (
                    <div key={index} className="mobile-nav-item">
                      <a href={item.href} className="mobile-nav-link">
                        {item.label}
                      </a>
                    </div>
                  );
                })}

                {/* Mobile Contact Us */}
                {!isSpecialPage && (
                  <div className="mobile-nav-item">
                    <a href="https://abym.in/contact-us" className="mobile-contact-btn">
                      Contact Us
                    </a>
                  </div>
                )}
              </div>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
